import topTitle from '@/components/title';
import { mailingLook, editMailing } from './../request';
import { logisticsSelectList } from '../utils';
export default {
  components: {
    topTitle
  },
  props: {
    claimsId: {
      type: Number,
      default: 0
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      logisticsSelectList,
      previewVisible: false,
      mailingInfo: {
        consigneeInfo: {
          name: '',
          mobile: '',
          address: ''
        }
      }
    };
  },
  created() {
    setTimeout(() => {
      this.init();
    }, 400);
  },
  computed: {
    mailingRule() {
      return {
        logisticsCompany: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('物流公司')
        }],
        shipmentNum: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('运单号')
        }, {
          message: this.$t('1-100字符'),
          max: 100,
          min: 1
        }]
      };
    }
  },
  methods: {
    async init() {
      this.mailingInfo = await mailingLook({
        claimsId: this.claimsId
      });
      this.previewVisible = true;
    },
    saveAdd() {
      this.$refs.addFormRef.validate(async valid => {
        if (valid) {
          let obj = {
            claimsId: this.mailingInfo.claimsId,
            logisticsCompany: this.mailingInfo.logisticsCompany,
            shipmentNum: this.mailingInfo.shipmentNum,
            consigneeId: this.mailingInfo.consigneeInfo.id
          };
          await editMailing(obj);
          this.previewVisible = false;
          this.$message.success(this.$t('保存成功'));
          this.$emit('save');
          this.resetForm();
        }
      });
    },
    resetForm() {
      this.$refs.addFormRef.resetFields();
    }
  }
};